<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="We just need a few more details to get you ready">
        <p class="mb-4">
          <strong>Are you registering as a company?</strong>
          <br>
          If you're looking to register as a company or another type of vehicle, please select an option below:
        </p>
        <base-button :to="{ name: 'register.company' }" class="mr-1" secondary>
          Register as a Company
        </base-button>
        <base-button :to="{ name: 'register.other' }">
          Register as another entity
        </base-button>
      </hero-header>
    </template>
    <template v-if="loaded">
      <form @submit.prevent="submit">
        <base-error v-model="error" />
        <user-details v-model="payload" registering />
        <div class="mt-4 text-right">
          <base-button icon-right="arrow-right" :loading="saving" secondary submit>
            Continue
          </base-button>
        </div>
      </form>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { RegistratesUser } from '@/mixins'

import HeroHeader from '@/components/HeroHeader.vue'
import UserDetails from '@/components/UserDetails.vue'

export default {
  components: {
    HeroHeader,
    UserDetails
  },

  mixins: [RegistratesUser],

  data: () => ({
    loaded: false,
    saving: false,
    payload: {}
  }),

  mounted () {
    this.payload = this.$_.cloneDeep(this.$auth.user)
    this.payload.profile.isCompany = false

    this.loaded = true
  },

  methods: {
    submit () {
      this.saving = true

      this.save()
        .then(() => {
          this.$router.push({
            name: this.$auth.investor() ? 'register.statutory' : 'dashboard'
          })
        })
        .catch(err => {
          this.error = err
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
